export default __webpack_public_path__ + "static/media/i-subjacentes.4dd45421.png";